import { MediaQueryController } from "media-query-controller";

class ProductCardGallery extends MediaQueryController {
  static values = {
    sectionId: String,
    small: Number,
    medium: Number,
    large: Number,
  };

  slidesPerView = {
    small: this.smallValue,
    medium: this.mediumValue,
    large: this.largeValue,
  };

  connect() {
    super.connect();

    this.swiper = new Swiper(
      `.product-card-gallery-swiper-container-${this.sectionIdValue}`,
      {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    );

    this.onWindowResize((activeBreakpoint) => {
      this.swiper.params.slidesPerView = this.slidesPerView[activeBreakpoint];
      this.swiper.update();
    });
  }
}

Stimulus.register("productCardGallery", ProductCardGallery);
